import { useSelector } from 'react-redux';

import { PageSubHeader } from '@/components/organisms/PageSubHeader';
import PageContentWrapper from '@/components/templates/PageContentWrapper';

import { MessagingNBA } from './MessagingNBA';
import { MessagingStandard } from './MessagingStandard';
import { CampaignBreadcrumbs } from '../../components/CampaignBreadcrumbs';
import { BuildPageLoadingState } from '../../components/CampaignLoadingState';
import { CampaignWrapper } from '../../components/CampaignWrapper';
import {
  selectDraftAutonomousActions,
  selectHasNbaConfig,
  selectSelectedCampaign,
} from '../../redux/selectors';

/**
 * Step 2 router: delegates to standard or NBA messaging.
 * Checks both sources: nba_config on the saved campaign (for page refreshes)
 * and autonomous_actions on the draft (for in-progress creation before Redux is refreshed).
 */
export const UnifiedMessaging = () => {
  const selectedCampaign = useSelector(selectSelectedCampaign);
  const hasNbaConfig = useSelector(selectHasNbaConfig);
  const autonomousActions = useSelector(selectDraftAutonomousActions);
  const isNba = hasNbaConfig || autonomousActions;

  if (!selectedCampaign) {
    return (
      <>
        <PageSubHeader breadcrumbs={<CampaignBreadcrumbs />} />
        <PageContentWrapper>
          <CampaignWrapper>
            <BuildPageLoadingState />
          </CampaignWrapper>
        </PageContentWrapper>
      </>
    );
  }

  if (isNba) {
    return <MessagingNBA />;
  }

  return <MessagingStandard />;
};
